"use client";

import { DownloadBrochureButton } from "@/components/BrochurePDF/DownloadBrochureButton";
import { SocialShare } from "@/components/ui/SocialShare";
import { cn } from "@/lib/format";

/**
 * Right-aligned action cluster for the package detail header: a "Download PDF"
 * button and a "Share" dropdown. Client component — both actions touch the
 * browser (`window.print`, `navigator.share`, clipboard) and read the live URL,
 * so nothing needs to be plumbed through the server render.
 */
export function TripActions({
  title,
  slug,
  className,
}: {
  title: string;
  slug: string;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2 print:hidden", className)}>
      <DownloadBrochureButton slug={slug} />
      <SocialShare title={title} variant="dropdown" />
    </div>
  );
}
